import { I18n } from 'i18n-js'

window.I18n = new I18n()

import './backbone/images'
import './backbone/sounds'
import './backbone/keepcon.js.coffee'
import './backbone/models/**/*.coffee'
import './backbone/methods/**/*.coffee'
import './backbone/methods/customer/**/*.coffee'
import './backbone/views/image_upload_view.js.coffee'
import './backbone/views/monitoring/reports/campaign/utils.js.coffee'
import './backbone/new_relic_event_logger.js.coffee'
import './backbone/views/**/*.coffee'
import './backbone/routers/**/*.coffee'